import { render, staticRenderFns } from "./salesAddonsList.vue?vue&type=template&id=fc635c0e&scoped=true"
import script from "./salesAddonsList.vue?vue&type=script&lang=js"
export * from "./salesAddonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc635c0e",
  null
  
)

export default component.exports